// extracted by mini-css-extract-plugin
module.exports = {"button":"_4f720283bf--button--tmiJO"};